<template>
    <Head>
        <title>Партнеры</title>
    </Head>

    <authenticated-layout :notifications="notifications" >


        <div class="p-6 bg-white">
            <div class="grid grid-cols-7 p-2 gap-2 text-sm items-end">
                <strong class="col-start-4">Ключи</strong>
                <strong class="text-center">Пополнение авансового баланса</strong>
                <strong class="text-center">Даты (UTC)</strong>
            </div>

            <div class="grid grid-cols-7 p-2 gap-4 items-center border-t" v-if="this.$page.props.auth.permissions.partners.create">
                <v-input label="Название" v-model="create.name"/>
                <v-input label="Email" v-model="create.email"/>
                <v-input label="Хост" v-model="create.host"/>
                <div></div>
                <div class="flex justify-center">
                    <v-toggle size="sm" v-model="create.allowBalanceReplenishment"/>
                </div>
                <div></div>
                <div class="flex flex-col gap-2">
                    <v-button color="green" @click="createPartner">Добавить</v-button>
                </div>
            </div>

            <div class="grid grid-cols-7 p-2 gap-4 items-center border-t" v-for="row in result">
                <v-input label="Название" v-model="row.name" @input="row.upd = true"/>
                <v-input label="Email" v-model="row.email" @input="row.upd = true"/>
                <v-input label="Хост" v-model="row.host" @input="row.upd = true"/>
                <div class="flex flex-col">
                    <v-label>Публичный</v-label>
                    <span class="text-sm">{{ row.publicKey }}</span>
                    <v-label>Приватный</v-label>
                    <span class="text-sm">{{ row.privateKey }}</span>
                </div>
                <div class="flex justify-center">
                    <v-toggle size="sm" v-model="row.allowBalanceReplenishment" @change="row.upd = true"/>
                </div>
                <div class="flex flex-col text-center">
                    <v-label>Создания</v-label>
                    <span class="text-sm">{{ moment(row.createdAt).utc().format('L LTS') }}</span>
                    <v-label>Обновления</v-label>
                    <span class="text-sm">{{ moment(row.updatedAt).utc().format('L LTS') }}</span>
                </div>
                <div class="flex flex-col gap-2" v-if="this.$page.props.auth.permissions.partners.update">
                    <v-button
                        color="yellow"
                        type="button"
                        @click="openKeys2fa(row)"
                    >Новые ключи</v-button>
                    <v-button
                        color="green"
                        type="button"
                        @click="update(row)"
                        :disabled="!(row.upd || false)"
                    >Обновить</v-button>
                </div>
            </div>

            <v-modal2fa
                :showing="confirm.show"
                @submit="updateKeys"
                @close="closeKeys2fa"
                v-model:secret="confirm.key"
                :error="errors.secret"
            >Обновить приватный и публичный ключи?</v-modal2fa>

        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/User';
import VInput from "@/Components/Input";
import VToggle from "@/Components/Toggle";
import VButton from "@/Components/Button";
import VLabel from "@/Components/Label";
import VModal2fa from "@/Components/2FAModal";
import moment from "moment";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        VInput,
        VToggle,
        VButton,
        VLabel,
        VModal2fa,
    },
    props: {
        notifications: Object,
        result: Object,
        errors: Object,
    },
    data () {
        return {
            confirm: {
                show: false,
                key: '',
                id: null,
            },
            create: useForm({
                name: '',
                email: '',
                host: '',
                allowBalanceReplenishment: false,
            }),
        }
    },
    methods: {
        moment,
        update(row) {
            const {name, email, host, allowBalanceReplenishment} = row;
            useForm({name, email, host, allowBalanceReplenishment})
                .put(this.route('partner.update', row.id));
        },
        createPartner() {
            this.create.post(this.route('partner.create'), {
                onSuccess: () => {
                    this.create.name = '';
                    this.create.email = '';
                    this.create.host = '';
                    this.create.allowBalanceReplenishment = false;
                },
            })
        },
        openKeys2fa(row) {
            this.confirm = {
                show: true,
                key: '',
                id: row.id,
            }
        },
        closeKeys2fa() {
            this.confirm = {
                show: false,
                key: '',
                id: null,
            }
        },
        updateKeys() {
            const {key, id} = this.confirm;
            useForm({
                'secret': key,
                regenerateKeys: true,
            }).put(this.route('partner.update', id), {
                onSuccess: () => this.closeKeys2fa(),
            });
        },
    },
}
</script>
